import {
  mdiCogOutline,
  mdiHomeOutline,
  mdiStarOutline,
  mdiHistory,
  mdiCodeTags,
  mdiCheckDecagramOutline,
  mdiAxis,
  mdiTriangleOutline,
  mdiWrenchOutline,
  mdiFolderOutline,
  mdiWifi,
  mdiFlash,
} from '@mdi/js'

import {
  HomeConfiguration,
  HomeSoftware,
  HomeStatus,
  HomeLicensing,
  HomeLogs,
  HomeSubscription,
  HomeProcesses,
  HomeSystemStates,
  HomeServices,
  HomeDevices,
  HomeJobInfo,
  HomeEnergySystem,
  HomeBreakerPanels,
  HomePowerCycle,
} from './components'
import NetworkDashboard from 'features/networkAi/NetworkDashboard'

interface Route {
  component: any
  icon: string
  path: string
  title: string
}

// TODO Localization
export function homeAsideRoutes(
  showEnergy = false,
  showPDU = false,
  showPanels = false
) {
  const defaultRoutes: Array<Route> = [
    {
      component: HomeStatus,
      icon: mdiHomeOutline,
      path: 'status',
      title: 'Home Status',
    },
    {
      component: HomeConfiguration,
      icon: 'm 6.0290665,15.982615 c -2.1053659,0 -3.8285869,1.722089 -3.8285869,3.827387 0,2.105365 1.723221,3.828588 3.8285869,3.828588 2.1053664,0 3.8273805,-1.723223 3.8273805,-3.828588 0,-2.105365 -1.7220141,-3.827387 -3.8273805,-3.827387 z m 0,1.487127 c 1.3011179,0 2.3390656,1.039146 2.3390656,2.34026 0,1.301121 -1.0379477,2.340271 -2.3390656,2.340271 -1.3011771,0 -2.3402688,-1.039092 -2.3402688,-2.340271 0,-1.301114 1.0390917,-2.34026 2.3402688,-2.34026 z m 9.0889095,-1.301958 a 0.74400897,0.74400897 0 0 0 -0.742992,0.744127 v 1.763718 a 0.74400897,0.74400897 0 0 0 0.742992,0.74413 0.74400897,0.74400897 0 0 0 0.744124,-0.74413 v -1.763718 a 0.74400897,0.74400897 0 0 0 -0.744124,-0.744127 z m -0.88711,0.882427 a 0.74400897,0.74400897 0 0 0 -0.74413,0.74413 0.74400897,0.74400897 0 0 0 0.74413,0.74413 h 1.769537 a 0.74400897,0.74400897 0 0 0 0.744124,-0.74413 0.74400897,0.74400897 0 0 0 -0.744124,-0.74413 z M 9.1062,3.8440534 v 1.488318 h 5.814914 V 3.8440534 Z M 14.176983,0.75965599 V 12.232389 c 0,0.958032 0.79399,1.751967 1.751963,1.751967 h 2.387136 c 1.343945,0 2.417239,1.11895 2.329703,2.496149 v 0.01051 c -0.0055,0.101465 -0.0023,0.113743 -0.0034,0.224997 -0.0016,0.111256 -0.0023,0.262376 -0.0035,0.440633 -0.0023,0.356498 -0.005,0.82153 -0.0081,1.285578 -0.0035,0.464023 -0.007,0.927194 -0.0117,1.279696 -0.0023,0.176261 -0.0049,0.325743 -0.0068,0.430079 -0.0016,0.03757 -0.0025,0.06035 -0.0035,0.08439 -0.213036,1.091178 -1.226652,1.907847 -2.400026,1.907847 H 6.0286075 v 1.488308 H 18.208183 c 1.867097,0 3.519158,-1.299556 3.867224,-3.125438 0.03415,-0.16697 0.01711,-0.134176 0.01878,-0.173436 0.0019,-0.04108 0.0034,-0.08908 0.0049,-0.146486 0.0025,-0.11482 0.0049,-0.266163 0.0068,-0.445314 0.0019,-0.142987 0.003,-0.344216 0.0049,-0.514462 h 0.02808 V 5.3498843 C 22.138673,2.8237351 20.074529,0.75959 17.548375,0.75959 Z M 15.6641,2.2479738 h 1.884392 c 1.721892,0 3.101967,1.3800764 3.101967,3.1019775 V 13.38885 c -0.653588,-0.523768 -1.438155,-0.892996 -2.334377,-0.892996 h -2.387136 c -0.158003,0 -0.26485,-0.10567 -0.26485,-0.263673 z M 6.0285865,0.75965599 C 3.9228608,0.75965599 2.2,2.4825172 2.2,4.5882419 V 20.086426 H 3.6883179 V 4.5882419 c 0,-1.3023158 1.0379525,-2.3402681 2.3402686,-2.3402681 1.3023155,0 2.3390674,1.0379523 2.3390674,2.3402681 V 19.527217 H 9.855975 V 4.5882419 c 0,-2.1057247 -1.7216651,-3.82858591 -3.8273885,-3.82858591 z M 14.644092,1.503785 v 11.986343 l 0.284761,0.01407 6.306082,0.315234 0.314069,-10.362124 -2.605122,-1.9535638 z m 0.600007,0.6000067 h 3.500442 l 2.194943,1.6464805 -0.285941,9.4381178 -5.409424,-0.27071 z',
      path: 'configuration',
      title: 'Configuration',
    },
    {
      component: HomeSoftware,
      icon: mdiCodeTags,
      path: 'software',
      title: 'Software Update',
    },
    {
      component: HomeSubscription,
      icon: mdiCheckDecagramOutline,
      path: 'subscriptions',
      title: 'Subscriptions',
    },
    {
      component: HomeLicensing,
      icon: mdiStarOutline,
      path: 'licensing',
      title: 'Licensing',
    },
    {
      component: HomeDevices,
      icon: mdiAxis,
      path: 'devices',
      title: 'Configured Devices',
    },
    {
      component: NetworkDashboard,
      icon: mdiWifi,
      path: 'network',
      title: 'Smart Network',
    },
    {
      component: HomeProcesses,
      icon: mdiTriangleOutline,
      path: 'processes',
      title: 'Host Processes',
    },
    {
      component: HomeSystemStates,
      icon: mdiWrenchOutline,
      path: 'system-states',
      title: 'System States',
    },
    {
      component: HomeServices,
      icon: mdiCogOutline,
      path: 'services',
      title: 'Services',
    },
    {
      component: HomeLogs,
      icon: mdiHistory,
      path: 'logs',
      title: 'Logs',
    },
    {
      component: HomeJobInfo,
      icon: mdiFolderOutline,
      path: 'job-info',
      title: 'Job Info',
    },
  ]

  const energyRoutes: Array<Route> = [
    {
      component: HomeEnergySystem,
      icon: mdiFlash,
      path: 'energy-system',
      title: 'Power System',
    },
  ]

  const panelRoutes: Array<Route> = [
    {
      component: HomeBreakerPanels,
      icon: 'M 11 0 C 10.6778 0 10.416016 0.2618257 10.416016 0.58398438 L 10.416016 2.3984375 C 10.416016 2.7205972 10.6778 2.9804688 11 2.9804688 C 11.3221 2.9804688 11.582031 2.7205972 11.582031 2.3984375 L 11.582031 0.58398438 C 11.582031 0.2618257 11.3221 0 11 0 z M 3.1054688 3.2285156 C 2.9561839 3.2285156 2.8072593 3.2859339 2.6933594 3.4023438 C 2.4655596 3.6351535 2.4655596 4.013284 2.6933594 4.2460938 L 3.9296875 5.5097656 C 4.1574873 5.7425754 4.5261065 5.7425754 4.7539062 5.5097656 C 4.981706 5.2769459 4.981706 4.9007885 4.7539062 4.6679688 L 3.5175781 3.4023438 C 3.4036782 3.2859339 3.2547536 3.2285156 3.1054688 3.2285156 z M 18.894531 3.2285156 C 18.745256 3.2285156 18.596322 3.2859339 18.482422 3.4023438 L 17.246094 4.6679688 C 17.018294 4.9007885 17.018294 5.2769459 17.246094 5.5097656 C 17.473894 5.7425754 17.842513 5.7425754 18.070312 5.5097656 L 19.306641 4.2460938 C 19.53444 4.013284 19.53444 3.6351535 19.306641 3.4023438 C 19.192741 3.2859339 19.043806 3.2285156 18.894531 3.2285156 z M 11.001953 4.1738281 C 7.4306067 4.1738281 4.5253906 7.1427524 4.5253906 10.792969 C 4.5253906 13.221466 5.8454371 15.461442 7.921875 16.619141 L 7.921875 17.986328 C 7.921875 18.367128 8.2230635 18.675781 8.5957031 18.675781 L 13.386719 18.675781 C 13.759318 18.675781 14.060547 18.367228 14.060547 17.986328 L 14.060547 16.621094 C 16.150745 15.467895 17.478516 13.226966 17.478516 10.792969 C 17.478516 7.1427524 14.57325 4.1738281 11.001953 4.1738281 z M 11.460938 6.78125 C 11.538851 6.7825639 11.614641 6.8474938 11.603516 6.9453125 L 11.148438 10.490234 L 13.720703 10.490234 C 13.830903 10.490234 13.899003 10.610684 13.845703 10.708984 L 10.722656 16.392578 C 10.644456 16.530878 10.437278 16.46314 10.455078 16.306641 L 10.814453 12.816406 L 8.28125 12.816406 C 8.1710801 12.816406 8.1029401 12.695956 8.15625 12.597656 L 11.335938 6.8535156 C 11.365225 6.8016494 11.41419 6.7804617 11.460938 6.78125 z M 1.0957031 10.134766 C 0.76645345 10.134766 0.5 10.401169 0.5 10.730469 C 0.5 11.059668 0.76645345 11.326172 1.0957031 11.326172 L 2.8203125 11.326172 C 3.1495622 11.326172 3.4160156 11.059668 3.4160156 10.730469 C 3.4160156 10.401169 3.1495622 10.134766 2.8203125 10.134766 L 1.0957031 10.134766 z M 19.179688 10.134766 C 18.850388 10.134766 18.583984 10.401169 18.583984 10.730469 C 18.583984 11.059668 18.850388 11.328125 19.179688 11.328125 L 20.904297 11.328125 C 21.233597 11.328125 21.5 11.059668 21.5 10.730469 C 21.5 10.401169 21.233597 10.134766 20.904297 10.134766 L 19.179688 10.134766 z M 9.1328125 19.595703 C 8.7601829 19.595703 8.4589844 19.904357 8.4589844 20.285156 C 8.4589844 20.665956 8.7601429 20.974609 9.1328125 20.974609 L 12.865234 20.974609 C 13.237834 20.974609 13.541016 20.665956 13.541016 20.285156 C 13.541016 19.904357 13.237834 19.595703 12.865234 19.595703 L 9.1328125 19.595703 z M 10.179688 21.871094 C 9.8231586 21.889561 9.5410156 22.19155 9.5410156 22.560547 C 9.5410156 22.941346 9.8421741 23.25 10.214844 23.25 L 11.789062 23.25 C 12.161762 23.25 12.464844 22.941346 12.464844 22.560547 C 12.464844 22.179647 12.161762 21.871094 11.789062 21.871094 L 10.214844 21.871094 C 10.203198 21.871094 10.191188 21.870498 10.179688 21.871094 z ',
      path: 'breaker-panels',
      title: 'Breaker Panels',
    },
  ]

  const pduRoutes: Array<Route> = [
    {
      component: HomePowerCycle,
      icon: 'M 9.33398,2 V 8.6 H 11.134 V 14 l 4.2,-7.2 h -2.4 L 14.734,2 Z M 10.134,9.12109 C 5.67121,9.62266 2.33398,11.6174 2.33398,13.9995 c 0,2.24 2.94,4.13 7,4.77 v 2.02 c 0,0.45 0.54,0.67 0.85002,0.35 l 2.79,-2.79 c 0.2,-0.2 0.2,-0.51 0,-0.71 l -2.79,-2.79 c -0.31002,-0.31 -0.85002,-0.09 -0.85002,0.36 v 1.52 c -3.15,-0.56 -5,-1.9 -5,-2.73 0,-0.8927 2.15637,-2.4097 5.80002,-2.8662 z m 4.8157,0.05146 -1.102,1.88925 c 4.0576,0.3398 6.4863,1.9903 6.4863,2.9377 0,0.66 -1.2,1.68 -3.32,2.34 -0.41,0.13 -0.68,0.51 -0.68,0.94 0,0.67 0.65,1.16 1.28,0.96 2.83,-0.88 4.72,-2.45 4.72,-4.24 0,-2.3075 -3.1316,-4.25157 -7.3843,-4.82695 z',
      path: 'power-cycle',
      title: 'Power Cycle',
    },
  ]

  let routes = defaultRoutes

  if (showEnergy) {
    routes = [...routes, ...energyRoutes]
  }
  if (showPanels) {
    routes = [...routes, ...panelRoutes]
  }
  if (showPDU) {
    return [...routes, ...pduRoutes]
  }

  return routes
}
